const KEY = 'orienta-stale-reload';

/** Erro de carregamento de módulo: a página foi aberta antes de um novo deploy e o arquivo não existe mais. */
export function isStaleBuildError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? '');
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i.test(message);
}

/**
 * Recarrega a página para buscar a versão nova — no máximo uma vez a cada 30 s,
 * para nunca entrar em ciclo se o erro persistir. Retorna false se não recarregou.
 */
export function reloadForNewBuild(): boolean {
  try {
    const last = Number(sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < 30_000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    /* sem sessionStorage: recarrega mesmo assim */
  }
  window.location.reload();
  return true;
}
